import React, { Component } from 'react'
import { Routes, Route } from 'react-router-dom'

import endPoints from '../../components/Consts/endPoints.json'

import { Changes, ChangesForm } from '../../views/Changes'

export default class ChangesRoute extends Component {
  render () {
    var releatedRoutes = endPoints.find(aa => aa.name == 'Changes')?.routes
    return (
      <Routes>
        <Route path={releatedRoutes?.get} exact element={<Changes />} />
        <Route path={releatedRoutes?.create} exact element={<ChangesForm />} />
        <Route path={releatedRoutes?.update} exact element={<ChangesForm />} />
        <Route path={releatedRoutes?.delete} exact element={<ChangesForm />} />
      </Routes>
    )
  }
}
